import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Experiencia } from '../models/experiencia';
import { HttpClient, HttpResponse } from '@angular/common/http';

const dataservice = 'assets/data/mock-dg-data.json';
@Injectable({
  providedIn: 'root'
})
export class DgService {

  disenoGrafico: Experiencia = new Experiencia();

  constructor(private http: HttpClient) { }

  getDg(): Observable<HttpResponse<Experiencia[]>> {
    return this.http.get<Experiencia[]>(
      dataservice, {observe: 'response'}
    );
  }
}
